var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-badge',_vm._b({scopedSlots:_vm._u([{key:"tooltip",fn:function(){return [_vm._v(" "+_vm._s(_vm.props.label)+" ")]},proxy:true}])},'icon-badge',_vm.props,false))}
var staticRenderFns = []

export { render, staticRenderFns }